import axios from "axios";
import { IsAuthorized } from "src/authentication/IsAuthorized";
import { getJWT } from "src/helper/localStore/getJWT";

class WorkUnitPerProductServices {
    async getByWorkUnit(work_unit_id:number): Promise<any[]> {
        try {
        const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-work-unit/work_unit_id/${work_unit_id}`, {
            headers: { 'authentication-token': getJWT()! }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async getProductsByWorkUnit(work_unit_id:number): Promise<any[]> {
        try {
        const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/work-unit/products/${work_unit_id}`, {
            headers: { 'authentication-token': getJWT()! },
            params:{
                filter_by_is_offline:false
            }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async editProductsByWorkUnit(id:number, body:any): Promise<any[]> {
        try {
        const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-work-unit/`,
            body, 
            {
            headers: { 'authentication-token': getJWT()! },
            params:{
                ent_id:id
            }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async createProductsByWorkUnit(body:any): Promise<any[]> {
        try {
        const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-work-unit/`,
            body, 
            {
            headers: { 'authentication-token': getJWT()! },
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async deleteProductsByWorkUnit(id:number): Promise<any[]> {
        try {
        const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-work-unit/`,
            {
            headers: { 'authentication-token': getJWT()! },
            params:{
                ent_id:id
            }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }
}

export const workUnitPerProductServices = new WorkUnitPerProductServices()